export default "__VITE_ASSET__3ctCaqU4__"